<template>
  <Loader v-if="loading" />
  <b-row v-else>
    <b-col cols="12" md="4">
      <List v-if="items.length" :list="items" @update="getAllHeadlines" />
      <SideBar @addline="addline" />
    </b-col>
    <b-col class="card" cols="12" md="8">
      <AddHeadline
        v-if="state.headlineForm && showAddline && !showEmpty"
        :clear="clearForm"
        @update="getAllHeadlines"
        :order="items.length"
        :key="$route.query.id"
        :default="currentHeadline"
      />
      <AddActivity v-if="state.fileCard" :key="fileRender" />
      <FileForm v-if="state.fileForm && ($route.query.fileId || $route.query.new)" @update="getAllHeadlines" :key="$route.query.fileId" />
      <Empty v-if="showEmpty" />
    </b-col>
  </b-row>
</template>

<script>
import SideBar from './SideBar.vue'
import Empty from './Empty.vue'
import AddHeadline from './AddHeadline.vue'
import dadbanCourseSessionProvider from '../../../services/dadban/healline'
import List from './List.vue'
import AddActivity from './AddActivity.vue'
import FileForm from './FileForm.vue'
import Loader from '../../widgets/loader.vue'

export default {
  components: { SideBar, Empty, AddHeadline, List, AddActivity, FileForm, Loader },
  data() {
    return {
      showAddline: false,
      showEmpty: true,
      items: [],
      currentHeadline: '',
      currentFile: '',
      fileRender: false,
      loading: true,
      clearForm: false,
    }
  },
  watch: {
    '$route.query.id'() {
      this.updateHeadlineForm()
    },
  },
  computed: {
    state() {
      return this.$store.state.headlines
    },
  },
  async mounted() {
    await this.getAllHeadlines()
    this.currentHeadline = await this.items[0]
    this.showAddline = true
    this.loading = false
  },
  methods: {
    addline(value) {
      this.clearForm = true
      this.$store.commit('headlines/SET_HEAD_LINE_FORM', true)
      this.showEmpty = false
      setTimeout(() => {
        this.clearForm = false
      }, 2000)
    },
    async getAllHeadlines() {
      const req = await dadbanCourseSessionProvider.getAllCourseSessions(this.$route.params.courseId)
      this.items = req.data.data.output.sort((a, b) => a.order - b.order)
      this.items = this.items.map((item) => {
        item.sessionFiles.sort((a, b) => a.order - b.order)
        return item
      })
      this.items.forEach((item) => {
        if (+item.id === +this.$route.query.id) {
          item.sessionFiles.forEach((file) => {
            this.$store.commit('headlines/SET_CURRENT_FILE_ID', file.id)
          })
        }
      })
      if (this.items.length > 0) {
        this.showEmpty = false
      }
      this.$store.commit('headlines/SET_ITEMS', this.items)
    },
    updateHeadlineForm() {
      this.showAddline = true
      this.items.forEach((item) => {
        if (+item.id === +this.$route.query.id) {
          this.currentHeadline = item
        }
        item.sessionFiles.forEach((file) => {
          if (+this.$route.query.fileId === +file.id) {
            this.currentFile = file
          }
        })
      })
    },
  },
}
</script>

<style></style>
